import { useState } from "react";
import { Card, CardBody } from "react-bootstrap";
import { BsGearFill } from "react-icons/bs";
import { FaXmark } from "react-icons/fa6";

const IconActionCard = ({ icon, title, description, colorSchema, iconColor = "dark", inProgress = false, clickHandler, cancelHandler }) => {

    const [hover, setHover] = useState(false);

    return (
        <Card
            className={hover && !inProgress && `shadow-lg border-${colorSchema}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{ overflow: "hidden", borderRadius: 15 }}
            onClick={() => !inProgress ? clickHandler() : cancelHandler && cancelHandler()}
        >
            <CardBody
                className={inProgress ? " text-dark" : ""}
                style={{ margin: -16, overflow: "hidden" }}
            >
                <div style={{ height: "100%", width: "100%", display: "flex" }}>
                    <div
                        className={`
                ${inProgress ? "bg-secondary text-light" : `bg-${colorSchema} text-${iconColor}`}
                d-flex align-items-center justify-content-center
            `}
                        style={{
                            width: "20%",
                            position: "relative",
                            overflow: "hidden"
                        }}
                    >
                        {inProgress && hover && (
                            <div className="danger-fill" />
                        )}

                        <div style={{ position: "relative", zIndex: 2 }}>
                            {inProgress
                                ? hover
                                    ? <FaXmark size={30} />
                                    : <BsGearFill className="rotating" size={30} />
                                : icon}
                        </div>
                    </div>

                    <div
                        className="d-flex flex-column"
                        style={{
                            width: "80%",
                            marginLeft: 20,
                            marginTop: 5,
                            marginBottom: 5,
                            userSelect: "none"
                        }}
                    >
                        <span>{title}</span>

                        {inProgress ? (
                            <small>
                                {hover? "Abbrechen": "In Bearbeitung..."}
                            </small>
                        ) : (
                            <small className="text-muted">{description}</small>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    )
}
export default IconActionCard;